import * as React from 'react'
import * as SelectPrimitive from '@radix-ui/react-select'
import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

import './select.css'
/* =========================
   Root
========================= */
export function Select(props) {
  return <SelectPrimitive.Root data-slot="select" {...props} />
}

export function SelectGroup(props) {
  return <SelectPrimitive.Group data-slot="select-group" {...props} />
}

export function SelectValue(props) {
  return <SelectPrimitive.Value data-slot="select-value" {...props} />
}

/* =========================
   Trigger
========================= */
export function SelectTrigger({
  className = '',
  size = 'default',
  children,
  ...props
}) {
  return (
    <SelectPrimitive.Trigger
      data-slot="select-trigger"
      data-size={size}
      className={`select-trigger select-trigger-${size} ${className}`}
      {...props}
    >
      {children}
      <SelectPrimitive.Icon>
        <ChevronDownIcon className="select-trigger-icon" />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>
  )
}

/* =========================
   Content
========================= */
export function SelectContent({
  className = '',
  children,
  position = 'popper',
  ...props
}) {
  return (
    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        data-slot="select-content"
        data-position={position}
        className={`select-content ${className}`}
        position={position}
        {...props}
      >
        <SelectScrollUpButton />

        <SelectPrimitive.Viewport className="select-viewport">
          {children}
        </SelectPrimitive.Viewport>

        <SelectScrollDownButton />
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  )
}

/* =========================
   Label
========================= */
export function SelectLabel({ className = '', ...props }) {
  return (
    <SelectPrimitive.Label
      data-slot="select-label"
      className={`select-label ${className}`}
      {...props}
    />
  )
}

/* =========================
   Item
========================= */
export function SelectItem({ className = '', children, ...props }) {
  return (
    <SelectPrimitive.Item
      data-slot="select-item"
      className={`select-item ${className}`}
      {...props}
    >
      <span className="select-item-indicator">
        <SelectPrimitive.ItemIndicator>
          <CheckIcon className="select-check-icon" />
        </SelectPrimitive.ItemIndicator>
      </span>

      <SelectPrimitive.ItemText>
        {children}
      </SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  )
}

/* =========================
   Separator
========================= */
export function SelectSeparator({ className = '', ...props }) {
  return (
    <SelectPrimitive.Separator
      data-slot="select-separator"
      className={`select-separator ${className}`}
      {...props}
    />
  )
}

/* =========================
   Scroll Buttons
========================= */
export function SelectScrollUpButton({ className = '', ...props }) {
  return (
    <SelectPrimitive.ScrollUpButton
      data-slot="select-scroll-up-button"
      className={`select-scroll-button ${className}`}
      {...props}
    >
      <ChevronUpIcon />
    </SelectPrimitive.ScrollUpButton>
  )
}

export function SelectScrollDownButton({ className = '', ...props }) {
  return (
    <SelectPrimitive.ScrollDownButton
      data-slot="select-scroll-down-button"
      className={`select-scroll-button ${className}`}
      {...props}
    >
      <ChevronDownIcon />
    </SelectPrimitive.ScrollDownButton>
  )
}
